// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


// Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

//======================================================================================================
// NOS SOLUTIONS
//======================================================================================================

if (document.querySelector('.home')) {

    // Agrandissement des blocs de la section "Nos solutions" au survol & focus

    document.addEventListener('DOMContentLoaded', function () {
        if (window.innerWidth >= 961) {
            var blocs = document.querySelectorAll('.solutions__bloc');
            var currentBloc = blocs[0];
            blocs[0].classList.add('biggest');
    
            for (var i = 0; i < blocs.length; i++) {

            blocs[i].addEventListener('mouseover', function () {
                currentBloc.classList.remove('biggest');
                this.classList.add('biggest');
                currentBloc = this;
            });

            blocs[i].addEventListener('mouseout', function () {
                this.classList.remove('biggest');
            });

            blocs[i].addEventListener('focus', function () {
                currentBloc.classList.remove('biggest');
                this.classList.add('biggest');
                currentBloc = this;
            });

            blocs[i].addEventListener('focusout', function () {
                this.classList.remove('biggest');
            });
            }

            document.addEventListener('mouseout', function () {
            blocs[0].classList.add('biggest');
            currentBloc = blocs[0];
            });
        }
    });

    // Déplacement du curseur sous les blocs de la section "Nos solutions" au hover & focus

    const blocs = document.querySelectorAll('.solutions__bloc');
    const progress = document.querySelector('.solutions__progress');

    progress.style.transform = `translateX(0px)`;

    blocs.forEach((bloc, index) => {
        if (window.innerWidth >= 961) {
            bloc.addEventListener('mouseover', () => {
                let translateX = 0;
                for (let i = 0; i < index; i++) {
                    if (window.innerWidth >= 961 && window.innerWidth <= 1200) {
                        translateX += 160;
                    }
                    else {
                        translateX += 200;
                    }
                }

                if (index === blocs.length - 1) {
                    progress.style.transform = `translateX(${translateX - 0}px)`;
                } else {
                    progress.style.transform = `translateX(${translateX}px)`;
                }
            });

            bloc.addEventListener('mouseout', () => {
                progress.style.transform = `translateX(0px)`;
            });

            bloc.addEventListener('focus', () => {
                let translateX = 0;
                for (let i = 0; i < index; i++) {
                    if (window.innerWidth >= 961 && window.innerWidth <= 1200) {
                        translateX += 160;
                    }
                    else {
                        translateX += 200;
                    }
                }

                if (index === blocs.length - 1) {
                    progress.style.transform = `translateX(${translateX - 0}px)`;
                    
                } else {
                    progress.style.transform = `translateX(${translateX}px)`;
                }
            });

            bloc.addEventListener('focusout', () => {
                progress.style.transform = `translateX(0px)`;
            });
        }
    });


    // Ajouter les classes liées à Swiper JS en 960 pour lancer le slider 

    const bloc = document.querySelector('.solutions__blocs');
    const wrapper = document.querySelector('.solutions__wrapper');
    const slides = document.querySelectorAll('.solutions__bloc');

    if (window.innerWidth <= 960) {
        bloc.classList.add('swiper-container');
        wrapper.classList.add('swiper-wrapper');
        slides.forEach(slide => {
            slide.classList.add('swiper-slide');
        });
    }

    //======================================================================================================
    // NOS CATALOGUES
    //======================================================================================================

    // Quand il n'y a qu'une seule slide sur la section nos catalogues elle prend une classe pour être visible

    if (window.innerWidth > 960) {
        const documentSlides = document.querySelectorAll('.swiper-container__images .swiper-slide');

        if (documentSlides.length <= 1) {
            documentSlides.forEach(documentSlide => {
                documentSlide.classList.add('only');
            });
        }
    }
}

//======================================================================================================
// MENU - Bouton "Boutique"
//======================================================================================================

// Bouton boutique qui remonte quand le menu est ouvert 

document.addEventListener("DOMContentLoaded", function() {
    var navMainButton = document.querySelector(".nav-main__button");
    var navMainBoutique = document.querySelector(".nav-main__boutique");
    
    navMainButton.addEventListener("change", function() {
        if (navMainButton.checked) {
            navMainBoutique.classList.add("checked");
        } else {
            navMainBoutique.classList.remove("checked");
        }
    });
});


//======================================================================================================
// RGAA - Ouverture du menu 
//======================================================================================================

if (window.innerWidth > 960) {

    // Ouvrir le menu au clavier 
    let menuBuger = document.getElementById("menu-btn");

    menuBuger.addEventListener('keydown', (e) => {
        if (e.keyCode != 13) {
            return;
        }
        menuBuger.toggleAttribute('checked');
    });

    // Lorsque que l'utilisateur check l'input le label prend le style du focus
    var input = document.querySelector('.nav-main__button');
    var label = document.querySelector('.nav-main__icon');

    input.addEventListener('focus', function() {
        label.classList.add('focused');
    });

    input.addEventListener('blur', function() {
        label.classList.remove('focused');
    });
}
